import React from "react";

/**
 * @component CompanyIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <CompanyIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const CompanyIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="CompanyIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 22H4V4a2 2 0 012-2h12a2 2 0 012 2v18zM6 20h5v-3.5h2V20h5V4H6v16zm11-4v2h-2v-2h2zm-8 0v2H7v-2h2zm8-5v2h-2v-2h2zm-4 0v2h-2v-2h2zm-4 0v2H7v-2h2zm4-5v2h-2V6h2zm4 0v2h-2V6h2zM9 6v2H7V6h2z"
      />
    </svg>
  )
);
CompanyIcon.displayName = "CompanyIcon";
export default CompanyIcon;
